import { ComputedHalfInfo } from "../models/ComputedHalfInfo";

/**
 * Format period end display minute with seconds accuracy
 * @param periodInfo - Computed half information
 * @returns Formatted string like "5'" or "5+2:14'"
 */
export function formatPeriodEndDisplay(periodInfo: ComputedHalfInfo): string {
    if (periodInfo.additionalTimeSeconds !== undefined && periodInfo.actualDurationSeconds !== undefined) {
        // Calculate total additional seconds
        const totalAdditionalSeconds = Math.max(
            periodInfo.actualDurationSeconds - (periodInfo.scheduledDurationMinutes * 60),
            0
        );

        // Use Math.floor for minutes (don't round up when showing seconds)
        const additionalMinutes = Math.floor(totalAdditionalSeconds / 60);
        const additionalSeconds = totalAdditionalSeconds % 60;

        return `${periodInfo.actualEndMinute}'+${additionalMinutes}:${additionalSeconds.toString().padStart(2, '0')}'`;
    }
    return `${periodInfo.actualEndMinute}'`;
}
